import React, { useEffect, useState } from 'react';
import ModalOverlay from './ModalOverlay';
import MarketplaceStrategyForm from './MarketplaceStrategyForm';
import { strategyFormFromRow } from '../utils/marketplaceStrategies';

/**
 * Модалка настроек биддера — layout как StrategyModal в BidderTargets (WB).
 */
export default function MarketplaceStrategyModal({
  open,
  onClose,
  title,
  subtitle,
  marketplace,
  initialRow,
  onSave,
  showBudget = true,
  showBidLimits = true,
  showStockThreshold = false,
}) {
  const [values, setValues] = useState(() => strategyFormFromRow(initialRow, marketplace));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && initialRow) {
      setValues(strategyFormFromRow(initialRow, marketplace));
    }
  }, [open, initialRow, marketplace]);

  if (!open || !initialRow) return null;

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(values);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalOverlay onClose={onClose}>
      <div
        className="modal-panel rounded-2xl p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3 className="text-xl font-semibold mb-1 text-gray-800">Настройки стратегии</h3>
        <p className="text-sm text-gray-500 mb-1">{title}</p>
        {subtitle && (
          <p className="text-sm text-indigo-700 bg-indigo-50 rounded-lg px-3 py-2 mb-4">{subtitle}</p>
        )}
        <MarketplaceStrategyForm
          marketplace={marketplace}
          values={values}
          onChange={setValues}
          showBudget={showBudget}
          showBidLimits={showBidLimits}
          showStockThreshold={showStockThreshold}
        />
        <div className="flex gap-3 mt-6 pt-4 border-t border-gray-100">
          <button
            type="button"
            className="flex-1 px-4 py-2.5 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Сохранение…' : 'Сохранить'}
          </button>
          <button
            type="button"
            className="px-4 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            onClick={onClose}
          >
            Отмена
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
